import z from 'zod'

export const statisticsFilterSchema = z.object({
  postedVideos: z.array(z.number()),
})

export type StatisticsFiltersForm = z.infer<typeof statisticsFilterSchema>

export const defaultValuesStatisticsFiltersForm: StatisticsFiltersForm = {
  postedVideos: [0, 50000000],
}
